import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/vanoce" as const,
	[Locale.en]: "/christmas" as const,
} satisfies LocalizedString;

export function getChristmasPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
